// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdTerritoriesUpdateArchivedStateResult = objectOf({
  info: string,
  undo_identifier: number,
  undo_data: objectOf({
    app_group_id: string,
    ids: objectOf({
      "64d13ec0a729d90053af991a": nullOrUndefined,
    }),
    mark_as_archived: boolean,
    undo_reversions: objectOf({}),
  }),
});
